<div class="error-message">
  {{ message }}
</div>
